// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Jxz_O","type":"styles_type__Zm39A","choices":"styles_choices__3M2IK"};